/**
 * MediaList dynamic/lazy import 시 공통으로 사용하는 요소 모음
 * LazyMediaList 에서 MediaList 에 있는 요소를 import 하면 빌드파일에 media-viewer가 포함되기 때문
 */

import { ThumbnailRatio, getThumbnailRatio } from '@local/utils'

import { MediaList_ReviewGroupFragment } from '@web/gql/graphql'

export const getHighestRatio = (mediaItems: MediaList_ReviewGroupFragment['mediaItems']) => {
  return mediaItems.reduce((highestRatio, mediaItem) => {
    const ratio = getThumbnailRatio(mediaItem)
    return ratio < highestRatio ? ratio : highestRatio
  }, ThumbnailRatio.LANDSCAPE)
}
